export default {
  companies: [],
  activeCompany: null,
  requestStatus: 'idle'
};
